import React, { useEffect, useRef, useState } from 'react'
import { nameCompareAZ, nameCompareZA, priceCompareMayor, priceCompareMinor, stockCompareMayor, stockCompareMinor } from '../../../utils/FilterUtils';
import MainTitle from '../maintitle/MainTitle';
import Button from '../button/ButtonMinimalist';
import './style.css'
import DropDownList from '../dropdownlist/DropDownList';

export default function AdvancedFilter({list, type, setList, active, setActive}) {

    let filterDisplay = useRef(null);

    useEffect(() => {
      if(active){
        filterDisplay.current.style.top = "70px";
      }else{
        filterDisplay.current.style.top = "-"+filterDisplay.current.offsetHeight+"px";
      }
    },[active, list])
    
    let tempList = null;

    //Filter Funcitions
    function OrderByMayorPrice(){
      tempList = list.sort(priceCompareMayor);
      setList(tempList);
    }

    function OrderByMinorPrice(){
      tempList = list.sort(priceCompareMinor);
      setList(tempList);
    }

    function OrderByNameDescendent(){
      tempList = list.sort(nameCompareAZ);
      setList(tempList);
    }

    function OrderByNameAscendent(){
      tempList = list.sort(nameCompareZA);
      setList(tempList);
    }

    function OrderByStockMayor(){
      tempList = list.sort(stockCompareMayor);
      setList(tempList);
    }

    function OrderByStockMinor(){
      tempList = list.sort(stockCompareMinor);
      setList(tempList);
    }

    function OnlyStock(){
      tempList = [];
      list.map((item) => {
        if(item.stock > 0){
          tempList = [...tempList, item];
        }
      })  
      setList(tempList);
    }

    //Other Functions
    function resetList(){
      setList(list);
    }


    //UI Elements
    const filter1 = (
      <>
        <Button text="Mayor Precio" onClick={OrderByMayorPrice}/>
        <Button text="Menor Precio" onClick={OrderByMinorPrice}/>
      </>
    )

    const filter2 = (
      <>
        <Button text="Ordenar de A - Z" onClick={OrderByNameDescendent}/>
        <Button text="Ordenar de Z - A" onClick={OrderByNameAscendent}/>
      </>
    )

    const filter3 = (
      <>
        <Button text="Solo con Stock" onClick={OnlyStock}/>
        <Button text="Mayor Stock" onClick={OrderByStockMayor}/>
        <Button text="Menor Stock" onClick={OrderByStockMinor}/>
      </>
    )

    const Display = (
      <div className='AdvancedFilter' ref={filterDisplay}>
        <MainTitle text="Filtrar Productos"/>

        <DropDownList id="d1" text="Ordenar por Precio" content={filter1} />
        
        <DropDownList id="d2" text="Ordenar por Nombre" content={filter2} />

        <Button text="Borrar Filtro" onClick={resetList}/>
        <Button text="Aplicar Filtro" onClick={() => setActive(!active)}/>
      </div>
    );

    //<DropDownList id="d3" text="Filtrar por Stock" content={filter3} />

  return (
    <>
      {Display}
    </>
  )
}